import React, { Component } from 'react'
import { connect } from 'react-redux'
import styles from '../../../styles/3ds2/main.module.css'
// import GooglePayTempTokenSample from '../samples/GooglePayTempTokenSample'
import { makeCavvPurchaseRequest } from '../../../actions/threeDSTwoActions'
import { updateOrderId } from '../../../actions/commonActions'
import { _3DS2, _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const OBJECT = [ "googlePayTokenTempAdd", "googlePayTokenTempAdd", "$googlePayTokenTempAdd"]

const METHODS = {
    store_id: [".SetStoreId(store_id);", ".setStoreId(store_id);", "'store_id'=>$store_id"],
    order_id: [ ".SetOrderId(order_id);", ".setOrderId(order_id);", "'order_id'=>$order_id"],
    api_token: [ ".SetApiToken(api_token);", ".setApiToken(api_token);", "'api_token'=>$api_token"],
    network: [ ".SetNetwork(network);", ".setNetwork(network);", "$network = \"MASTERCARD\";"],
    payment_token: ["SetPaymentToken(signature,\n protocol_version, signed_message);", "setPaymentToken(signature,\n protocol_version, signed_message);", "setPaymentToken($signature,\n $protocol_version, $signed_message);"],
    signature: ["String signature = \"ME...\";", "String signature = \"ME...\";", "$signature = \"ME...\";"],
    protocol_version: ["String protocol_version = \"ECv1\";", "String protocol_version = \"ECv1\";", "$protocol_version = \"ECv1\";"],
    signed_message: ["String signed_message =\n \"{\\\"encryptedMessage\\...\";", "String signed_message =\n \"{\\\"encryptedMessage\\...\";", "$signed_message =\n \"{\\\"encryptedMessage\\...\"}\";"],
}

class GooglePayTempToken extends Component {
    state = {
        topRef: React.createRef()
    }

    generateOrderId() {
        const d = new Date();
        var orderId = "Test";
        orderId += d.getFullYear().toString();
        orderId += d.getMonth().toString();
        orderId += d.getDay().toString();
        orderId += d.getHours().toString();
        orderId += d.getMinutes().toString();
        orderId += d.getSeconds().toString();
        return orderId;
    }

    getOrderId() {
        const { order_id } = this.props;
        if(order_id === "none")
            return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
        else
            return `"${order_id}"`;
    }

    async onCavvPurchasePress() {
        const { cavvPurchaseSuccess, loading } = this.props;
        const { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci } = this.props;

        if(loading || cavvPurchaseSuccess || eci === cavv ) return;

        if(order_id === 'none') {
            const newOrderId = await this.generateOrderId();
            this.props.updateOrderId({ featureId: _3DS2, orderId: newOrderId });
        }
        const cavvPurchaseRequest = { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci };
        this.props.makeCavvPurchaseRequest(cavvPurchaseRequest);
    }

    renderBtn() {
        const { loading, cavvPurchaseSuccess, eci, cavv } = this.props;

        if(!(loading || cavvPurchaseSuccess || eci === cavv)) {
            return (
                <div style={{marginLeft: '20%'}} className={"requestButton"} onClick={() => this.onCavvPurchasePress()}>
                    Cavv Purchase Request
                </div>
            );
        }
        else {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'left'}}>
                     <div className="disabledButton">
                        Cavv Purchase Request
                     </div>
                     <i style={{marginLeft: '1vw', fontSize: '0.8rem', color: 'red'}}>* To make this request you need to get cavv and eci (crypt type) by making 3DS Auth request.</i>
                </div>
            );
        }
    }

    renderInteractiveTool() {
        const { leftContents } = styles;

        return (
            <div className={leftContents}>
                <div ref={this.state.topRef} style={{ paddingLeft: '1vw', paddingRight: '2vw', marginBottom: '10%'}}>
                    <h3>Sample Purchase with 3-D Secure – cavvPurchase</h3>
                    {this.renderBtn()}
                </div>
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <div ref={this.state.topRef}>
                    <span className="stepPageTitle"><b>GooglePay Temporary Token Add – GooglePayTokenTempAdd</b></span>
                    
                    <p>Creates a new temporary token credit card profile from an encrypted GooglePay payload. During the lifetime of this temporary token, it may be used to perform 3DS authentication and financial transactions via GooglePay Token Preauthorization or GooglePay Token Purchase.</p>
                    <p>The response field <i>GooglePaymentMethod</i> returned by this request will inform you if the underlying card within GooglePay is the funding card number ("FPAN") or a tokenized card number ("DPAN"). If a GoogleTokenTempAdd returns an FPAN, you may peform 3DS authentication with it; if it returns a DPAN, 3DS is not required.</p>
                    <p>Refer to Apple or Google developer portals for details on integrating directly to their wallets to retrieve the payload data.</p>

                    <div style={{ backgroundColor: '#9df0ef', padding: '2px 10px', border: '1px solid #000', borderRadius: '10px', marginBottom: '5vh', marginTop: '5vh', marginRight: '2vw' }}>
                        <p><b>Things to Consider: </b> The duration, or lifetime, of the temporary token can be set to be a maximum of 15 minutes.</p>
                    </div>

                    <p><b>GooglePay Temporary Token Add transaction object definition</b></p>
                    {(() => {
                    switch(progLangId) {
                        case _DOTNET:
                            return <code>GooglePayTokenTempAdd googlePayTokenTempAdd = new GooglePayTokenTempAdd();</code>
                        case _JAVA:
                            return <code>GooglePayTokenTempAdd googlePayTokenTempAdd = new GooglePayTokenTempAdd();</code>
                        case _PHP:
                            return <code>{"$txnArray = array(‘type’=>’googlePayTokenTempAdd', …);"}<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                        default:
                            return null
                        }
                    })()}

                    <p style={{ marginTop: '5vh' }}><b>HttpsPostRequest object for Cavv Purchase for Apple Pay & Google Pay™ transaction</b></p>
                    {(() => {
                        switch(progLangId) {
                            case _DOTNET:
                                return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(googlePayTokenTempAdd);</code>
                            case _JAVA:
                                return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(GooglePayTokenTempAdd);</code>
                            case _PHP:
                                return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                            default:
                                return null
                        }
                    })()}

                    <h3 style={{ marginTop: '7vh'}}>Core connection object fields (all API transactions)</h3>
                    <table className='four_cols_table'>
                        <th>Variable Name</th>
                        <th>Description</th>
                        <th>Type and Limits</th>
                        <th>Set Method</th>

                        <tr>
                            <td>store ID</td>
                            <td>Unique identifier provided by Moneris upon merchant account setup</td>
                            <td><i>String</i><br /><br /> N/A</td>
                            <td><code>{progLangId !== _PHP ? 'mpgReq' : ''}{METHODS.store_id[progLangId]}</code></td>
                        </tr>
                        <tr>
                            <td>API token</td>
                            <td>Unique alphanumeric string assigned by Moneris upon merchant account activation</td>
                            <td><i>String</i><br /><br /> N/A</td>
                            <td><code>{progLangId !== _PHP ? 'mpgReq' : ''}{METHODS.api_token[progLangId]}</code></td>
                        </tr>
                    </table>
                    
                    <h3 style={{ marginTop: '10vh'}}>GooglePay Temporary Token Add transaction request fields – Required</h3>
                    <p>For a full description of mandatory and optional values, see Appendix A Definition of Request Fields.</p>
                    <table>
                        <th>Variable Name</th>
                        <th>Type and Limits</th>
                        <th>Set Method</th>

                        <tr>
                            <td>network</td>
                            <td><i>String</i><br /><br /> alphabetic</td>
                            <td><code>{OBJECT[progLangId]}{METHODS.network[progLangId]}</code><br />Card Brand name.<br />Field is case sensitive Possible values:<br />Visa<br />Mastercard<br />American Express<br />Interac<br />Discover</td>
                        </tr>
                        <tr>
                            <td>payment token</td>
                            <td><i>Object</i><br /><br /> N/A</td>
                            <td>{progLangId !== _PHP ? '' : <code>{OBJECT[progLangId]}{METHODS.payment_token[progLangId]}</code>}<br /><p>Payment details returned by Google in their PaymentData object for GooglePay transactions. See GooglePay Payment Token object request fields – Required below for field details.</p></td>
                        </tr>
                    </table>

                    <h3 style={{ marginTop: '10vh'}}>GooglePay Payment Token object request fields – Required</h3>
                    <table>
                        <th>Variable Name</th>
                        <th>Type and Limits</th>
                        <th>Set Method</th>

                        <tr>
                            <td>signature</td>                        
                            <td><i>String</i><br />N/A</td>
                            <td><code>{METHODS.signature[progLangId]}</code><br /><p>Verifies that the message came from Google. It's base64-encoded, and created with ECDSA by the intermediate signing key. Returned by Google in their PaymentData object for GooglePay transactions</p></td>
                        </tr>
                        <tr>
                            <td>protocol version</td>
                            <td><i>String</i><br />N/A</td>
                            <td><code>{METHODS.protocol_version[progLangId]}</code><br /><p>Identifies the encryption or signing scheme under which the message is created. It allows the protocol to evolve over time, if needed. Returned by Google in their PaymentData object for GooglePay transactions</p></td>
                        </tr>
                        <tr>
                            <td>signed message</td>
                            <td><i>String</i><br />N/A</td>      
                            <td><code>{METHODS.signed_message[progLangId]}</code><br /><p>A JSON object serialized as an HTMLsafe string that contains the encryptedMessage, ephemeralPublicKey, and tag. It's serialized to simplify the signature verification process. Returned by Google in their PaymentData object for GooglePay transactions</p></td>
                        </tr>
                    </table>

                    {/* <GooglePayTempTokenSample /> */}
                </div>
            </div>
        )
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderInteractiveTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { storeId, apiToken, order_id, pan, expdate, amount, cavv, eci } = state.threeDSTwo.main.config;
    const { loading, cavvPurchaseSuccess, cavvLookupSuccess } = state.threeDSTwo.main;
    const { mode } = state.common.sideNav;
    const { selection } = state.threeDSTwo.stepsList;
    return { cavvPurchaseSuccess, cavvLookupSuccess, selectedStep: selection, mode, loading, storeId, apiToken, order_id, pan, expdate, amount, cavv, eci, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makeCavvPurchaseRequest, updateOrderId})(GooglePayTempToken)
